import styled from '@emotion/styled'

export const EditorContent = styled.div`
  overflow: hidden;
  overflow-y: auto;
  flex-grow: 1;

  /* Add space below name inputs to prevent validation error overlap */
  .logic-set-name-input,
  .timer-name-input {
    margin-bottom: 20px;
  }

  .form-field {
    > label {
      margin-top: 12px;
      line-height: 20px;
    }
  }

  .editor-column {
    display: flex;

    > div + div {
      margin-left: 2em;
    }
  }

  .form-field > label,
  .editor-section {
    margin-top: 20px;
  }

  .ant-radio-group {
    margin-right: 0;
  }

  .ant-radio-group label {
    font-size: 12px;
    text-align: center;
  }

  .queries-used {
    margin: 1.5em 0 3em 0;
  }

  .edge-editor {
    width: 100%;
  }
`
